import compileHeaders from './compileHeaders';
import queryString from 'query-string';
import toAPIUrl from './toAPIUrl';
/**
 * Request compilations
 *
 * @param  {Object} state - applicaton state
 * @param  {String} path - API method path
 * @param  {Method} method - HTTP method
 * @param  {Object} query - query params
 * @param  {Object} body - request body
 * @param  {Object} headers - request headers
 * @return {Object} - compiled request
 */

export default function compileRequest(_ref) {
  var state = _ref.state,
      path = _ref.path,
      method = _ref.method,
      query = _ref.query,
      body = _ref.body,
      headers = _ref.headers;
  var options = {
    credentials: 'include',
    headers: compileHeaders(state, headers),
    method: method
  };
  var url = toAPIUrl(state, path);
  var stringifiedQuery = queryString.stringify(query);
  var urlWithQuery = stringifiedQuery ? "".concat(url, "?").concat(stringifiedQuery) : url;
  if (method !== 'get') options.body = JSON.stringify(body);
  return {
    url: urlWithQuery,
    options: options
  };
}